import { createLocation, useHistory } from 'quartz-routing/react-router';
export const useHref = to => {
  const history = useHistory();
  to = typeof to === 'function' ? to(history.location) : to;
  const location = typeof to === 'string' ? createLocation(to, undefined, undefined, history.location) : to;
  return history.createHref(location);
};